import { useContext } from 'react';
import { HelpContext } from '../../components/HelpProvider';

export default function useHelpContext() {
  const context = useContext(HelpContext);
  if (!context) throw new Error('useHelpContext must be within a HelpProvider');
  return context;
}
